import React, { useEffect, useState } from "react";
import { Modal, Button, Form, InputGroup, Alert } from "react-bootstrap";
// import "./styleModal.css";
import moment from "moment";
import 'moment-timezone';
// import { MdOutlineRadioButtonChecked } from "react-icons/md";
// import { toast } from "react-toastify";
import { COLOR_APP, COLOR_TEXT, LINEAR_GRADIENT_BG } from "../../constants";
import { FaCheckCircle } from "react-icons/fa";

export default function CurrentDateModal({
  openModal,
  onCloseModal,
  setCdFillter,
  setActiveButton,
  activeButton,
  backdrop
}) {

  // default this month
  let defaultStartMonth = moment().startOf("month").format("YYYY-MM-DD");
  let defaultEndMonth = moment().endOf("month").format("YYYY-MM-DD");

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isValidate, setIsValidate] = useState(false)

  useEffect(() => {
    if (activeButton === "thisMonth") {
      setCdFillter({
        createdAt_gte: defaultStartMonth,
        createdAt_lt: defaultEndMonth,
      });
    } else if (activeButton === "lastMonth") {
      onSelectDayBox("lastMonth");
    } else if (activeButton === "thisWeek") {
      onSelectDayBox("thisWeek");
    } else if (activeButton === "yesterday"){
      onSelectDayBox("yesterday");
    } else if (activeButton === "today"){
      onSelectDayBox("today")
    }else {
      setCdFillter();
    }
  }, []);

  useEffect(() => {
    setIsValidate(false)
  }, [startDate && endDate])

  const getStartDate = (filter) => {
    switch (filter) {
      case "today":
        return moment().format("YYYY-MM-DD");
      case "yesterday":
        return moment().subtract(1, "day").startOf("day").format("YYYY-MM-DD");
      case "thisWeek":
        return moment().startOf("week").format("YYYY-MM-DD");
      case "lastWeek":
        return moment().subtract(1, "week").startOf("week").format("YYYY-MM-DD");
      case "thisMonth":
        return moment().startOf("month").format("YYYY-MM-DD");
      case "lastMonth":
        return moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD");
      case "thisYear":
        return moment().startOf("year").format("YYYY-MM-DD");
      case "lastYear":
        return moment().subtract(1, "year").startOf("year").format("YYYY-MM-DD");
      default:
        return null;
    }
  };

  const getEndDate = (filter) => {
    switch (filter) {
      case "today":
        return moment().format("YYYY-MM-DD");
      case "yesterday":
        return moment().subtract(1, "day").endOf("day").format("YYYY-MM-DD");
      case "thisWeek":
        return moment().endOf("week").format("YYYY-MM-DD");
      case "lastWeek":
        return moment().subtract(1, "week").endOf("week").format("YYYY-MM-DD");
      case "thisMonth":
        return moment().endOf("month").format("YYYY-MM-DD");
      case "lastMonth":
        return moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
      case "thisYear":
        return moment().endOf("year").format("YYYY-MM-DD");
      case "lastYear":
        return moment().subtract(1, "year").endOf("year").format("YYYY-MM-DD");
      default:
        return null;
    }
  };

  const convertCurrentDate = (data) => {
    const thaiTimezone = moment(data).tz("Asia/Bangkok").format("DD/MM/YYYY");

    return thaiTimezone;
  };

  const onChangeStartDate = (e) => {
    setStartDate(e?.target?.value);
  };
  const onChangeEndDate = (e) => {
    setEndDate(e?.target?.value);
  };
  const onCloseElementAll = () => {
    onCloseModal();
  };

  const onSaveMyCurrentDate = () => {
    if (!startDate && !endDate) {
      setIsValidate(true)
      return;
    }
    onCloseModal();
    setStartDate()
    setEndDate()
    setActiveButton()
    setCdFillter({
      createdAt_gte: startDate,
      createdAt_lt: endDate,
    });


  };

  const onSelectDayBox = async (data) => {
    setActiveButton(data);
    setIsValidate(false)
    const _startDate = getStartDate(data);
    const _endDate = getEndDate(data);


    await setCdFillter({
      createdAt_gte: _startDate,
      createdAt_lt: _endDate,
    });
    onCloseModal();
  };

  const isActive = {
    cursor: "pointer",
  };

  const active = {
    cursor: "pointer",
    color: COLOR_TEXT,
    outline: `1px solid ${COLOR_TEXT}`,
    background: '#fff',
  };

  return (
    <Modal centered show={openModal}
      backdrop={backdrop ? backdrop : false} // Set backdrop to false to remove it
      keyboard={false}
    >
      <Modal.Body style={{ background: '#f1f1f1', borderRadius: 5, overflow: "hidden" }}>
        {isValidate ? (
          <Alert variant="danger" className="d-flex justify-content-center align-items-center" show={isValidate} onClick={() => setIsValidate(false)}>
            <p>ກະລຸນາເລືອກ ວັນທີ,ເດືອນ,ປີ ກ່ອນ!</p>
          </Alert>
        ) : (
          <p style={{
            fontSize: 18,
            paddingTop: 5,
            width: "100%",
            textAlign: "center",
            color: COLOR_TEXT,
            borderRadius: 10
          }}>
            {!startDate ? (
              "ຂໍ້ມູນທີ່ທ່ານເລືອກ"
            ) : (
              <>
                {convertCurrentDate(startDate) +
                  " - " +
                  convertCurrentDate(endDate)}
              </>
            )}
          </p>
        )}

        <div className="card-input-date">
          <InputGroup className="mb-3">
            <Form.Control
              value={startDate}
              onChange={(e) => onChangeStartDate(e)}
              type="date"
              aria-label="startDate"
            />
            <InputGroup.Text style={{ background: '#fff' }}>ຫາ</InputGroup.Text>
            <Form.Control
              value={endDate}
              onChange={(e) => onChangeEndDate(e)}
              type="date"
              aria-label="endDate"
            />
          </InputGroup>
        </div>

        <div className="card-day-select">

          <div
            style={activeButton === "today" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("today")}
          >
            <div>
              {activeButton === "today" && <div>
                <FaCheckCircle style={{ fontSize: 18 }} />
              </div>}
            </div>
            ມື້ນີ້
          </div>
          <div
            style={activeButton === "yesterday" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("yesterday")}
          >
            {activeButton === "yesterday" && <div>
              <FaCheckCircle style={{ fontSize: 18 }} />
            </div>}
            ມື້ວານນີ້
          </div>
          <div
            style={activeButton === "thisWeek" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("thisWeek")}
          >
            {activeButton === "thisWeek" && <div>
              <FaCheckCircle style={{ fontSize: 18 }} />
            </div>}
            ອາທິດນີ້
          </div>
          <div
            style={activeButton === "lastWeek" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("lastWeek")}
          >
            {activeButton === "lastWeek" && <div>
              <FaCheckCircle style={{ fontSize: 18 }} />
            </div>}
            ອາທິດກ່ອນ
          </div>
          <div
            style={activeButton === "thisMonth" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("thisMonth")}
          >
            {activeButton === "thisMonth" && <div>
              <FaCheckCircle style={{ fontSize: 18 }} />
            </div>}
            ເດືອນນີ້
          </div>
          <div
            style={activeButton === "lastMonth" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("lastMonth")}
          >
            {activeButton === "lastMonth" && <div>
              <FaCheckCircle style={{ fontSize: 18 }} />
            </div>}
            ເດືອນກ່ອນ
          </div>
          <div
            style={activeButton === "thisYear" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("thisYear")}
          >
            {activeButton === "thisYear" && <div>
              <FaCheckCircle style={{ fontSize: 18 }} />
            </div>}
            ປີນີ້
          </div>
          <div
            style={activeButton === "lastYear" ? active : isActive}
            className="card-day"
            onClick={() => onSelectDayBox("lastYear")}
          >
            {activeButton === "lastYear" && <div>
              <FaCheckCircle style={{ fontSize: 18 }} />
            </div>}
            ປີທີ່ແລ້ວ
          </div>
        </div>
        {/* <p
          style={{
            textAlign: "center",
            paddingTop: 10,
            width: "100%",
            color: "#b0b0b0",
            fontWeight: 100,
          }}
        >
          ເລືອກເອົາ ວັນທີ ທີ່ທ່ານຕ້ອງການ ຫຼື ມື້ ທີ່ທ່ານຕ້ອງການ
        </p> */}
      </Modal.Body>
      <Modal.Footer style={{ border: "none", display: 'flex', gap: 5, justifyContent: 'end', width: '100%', background: '#f1f1f1' }}>
        <Button variant="outline-secondary" style={{ minWidth: 100 }} onClick={onCloseElementAll}>
          ຍົກເລີກ
        </Button>
        <Button style={{ background: COLOR_APP, border: 'none', minWidth: 100 }} onClick={onSaveMyCurrentDate}>
          ຢືນຢັນ
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
